"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var colorConfig_1 = require("./colorConfig");
var ColorInput_1 = __importDefault(require("./ColorInput"));
var ColorPickerTool_1 = __importStar(require("./ColorPickerTool"));
var makeMaterialUIColors_1 = __importDefault(require("./makeMaterialUIColors"));
var PickedColors_1 = __importDefault(require("./PickedColors"));
var ShadeSlider_1 = __importDefault(require("./ShadeSlider"));
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(0.5),
        maxWidth: colorConfig_1.PICKER_TOOL_WIDTH + theme.spacing(0.5)
    }
}); });
var Actions = /** @class */ (function () {
    function Actions() {
    }
    Actions.setColorAction = function (params) { return function (dispatch) {
        var colorNow = ColorPickerTool_1.getPickedColorNow(params);
        dispatch(colorNow);
    }; };
    return Actions;
}());
exports.Actions = Actions;
var ColorPickerToolContainer = function (props, ref) {
    var classes = useStyles();
    var label = props.label;
    var _a = react_1.useState('#fff'), pickedColor = _a[0], setColor = _a[1];
    var _b = react_1.useState(), pickedColorIndex = _b[0], setColorIndex = _b[1];
    var _c = react_1.useState(colorConfig_1.defaultColorShadeIndex), sliderVal = _c[0], setSliderVal = _c[1];
    react_1.useImperativeHandle(ref, function () { return ({
        getPickedColor: function () { return pickedColor; }
    }); }, [pickedColor]);
    var colorShade = colorConfig_1.colorShades[sliderVal];
    var handleInputColor = react_1.useCallback(function (e) {
        var color = e.target.value;
        setColor(color);
    }, []);
    var handlePickColor = react_1.useCallback(function (index, color) {
        return function () {
            setColorIndex(index);
            setColor(color);
        };
    }, []);
    var handleChange = react_1.useCallback(function (e, val) {
        setSliderVal(val);
    }, []);
    react_1.default.useEffect(function () {
        Actions.setColorAction({
            colorsArr: makeMaterialUIColors_1.default,
            colorIndex: pickedColorIndex,
            colorShade: colorShade,
        })(setColor);
    }, [colorShade, pickedColorIndex]);
    return (react_1.default.createElement(core_1.Box, { className: classes.root },
        react_1.default.createElement(core_1.Typography, { variant: 'h6' }, label),
        react_1.default.createElement(PickedColors_1.default, { pickedColor: pickedColor }),
        react_1.default.createElement(ColorInput_1.default, { onChange: handleInputColor, value: pickedColor }),
        react_1.default.createElement(ColorPickerTool_1.default, { colorShade: colorShade, pickedColorIndex: pickedColorIndex, pickFn: handlePickColor }),
        react_1.default.createElement(ShadeSlider_1.default, { onChangeFn: handleChange, sliderVal: sliderVal })));
};
exports.default = react_1.forwardRef(ColorPickerToolContainer);
